import { useCallback, useState } from "react";

function useApi<T>(apiFunc: (...args: Array<any>) => Promise<T>) {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const callApi = useCallback(async (...args: Array<any>) => {
        setError("");
        setLoading(true);
        try {
            const response = await apiFunc(...args);
            setData(response);
        } catch (error: any) {
            setError(error.message || 'Unknown Error');

        } finally {
            setLoading(false);
        }
    }, [apiFunc]);


    return { callApi, data, error, loading, };
};

export default useApi;